import { sameSkuCode } from "../../utils/findSkuDetail";
import INVENTORY_API_BASE_URL from "../../config/api";














































































import { useState, useEffect, useRef } from "react";
import "./scanhashing.css";
import Axios from "axios";
import swal from "sweetalert";
import Table from "react-bootstrap/esm/Table";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import { io } from "socket.io-client";

const SCAN_PAGE_SIZE = 30;

const Scanhashing = () => {
  const [checkboxClickCount, setCheckboxClickCount] = useState(0);
  const [barcode] = useState("");
  const [barcodeData, setBarcodeData] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [selectedRowBarcodeData, setSelectedRowBarcodeData] = useState();
  const [count, setCount] = useState(0);
  const [data1, setdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const barcodeInputRef = useRef(null);
  const [selectedRowShelfData, setSelectedRowShelfData] = useState([]);
  const [selectedShelfId, setSelectedShelfId] = useState(null);
  const [barcodeSet, setBarcodeSet] = useState(new Set());
  const scannedRef = useRef(new Set());

  const [keyForBarcode, setKeyForBarcode] = useState("");
  const [loading, setLoading] = useState(false);
  const [batchPage, setBatchPage] = useState(1);
  const [shelfPage, setShelfPage] = useState(1);
  const [barcodePage, setBarcodePage] = useState(1);
  const baseUrl = `${INVENTORY_API_BASE_URL}`;

  const matchingShelfRows = selectedRow
    ? selectedRowShelfData.filter((item) => sameSkuCode(item.sku, selectedRow.sku))
    : [];
  const visibleBatchRows = filteredData.slice(
    (batchPage - 1) * SCAN_PAGE_SIZE,
    batchPage * SCAN_PAGE_SIZE
  );
  const visibleShelfRows = matchingShelfRows.slice(
    (shelfPage - 1) * SCAN_PAGE_SIZE,
    shelfPage * SCAN_PAGE_SIZE
  );
  const visibleBarcodes = barcodeData.slice(
    (barcodePage - 1) * SCAN_PAGE_SIZE,
    barcodePage * SCAN_PAGE_SIZE
  );

  const renderPagination = (label, page, totalItems, setPage) => {
    const pageCount = Math.ceil(totalItems / SCAN_PAGE_SIZE);
    if (pageCount <= 1) return null;

    const firstItem = (page - 1) * SCAN_PAGE_SIZE + 1;
    const lastItem = Math.min(page * SCAN_PAGE_SIZE, totalItems);

    return (
      <nav className="scan-pagination" aria-label={label + " pagination"}>
        <span className="scan-pagination-summary">
          Showing {firstItem.toLocaleString()}–{lastItem.toLocaleString()} of{" "}
          {totalItems.toLocaleString()}
        </span>
        <div className="scan-pagination-controls">
          <button
            className="scan-pagination-button"
            type="button"
            onClick={() => setPage(page - 1)}
            disabled={page <= 1}
            aria-label={"Previous page of " + label}
          >
            Previous
          </button>
          <span className="scan-pagination-current" aria-live="polite">
            Page {page} of {pageCount}
          </span>
          <button
            className="scan-pagination-button"
            type="button"
            onClick={() => setPage(page + 1)}
            disabled={page >= pageCount}
            aria-label={"Next page of " + label}
          >
            Next
          </button>
        </div>
      </nav>
    );
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/api/creategrn/getgrn`).then(
      (response) => {
        const sortedData = response.data.sort((a, b) => {
          const dateA = new Date(a.grndate);
          const dateB = new Date(b.grndate);
          return dateB - dateA;
        });

        setdata(sortedData);
      }
    );
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        const newBarcodeSet = new Set();
        response.data.forEach((item) => {
          if (item.barcodeData) {
            item.barcodeData.forEach((barcode) => newBarcodeSet.add(barcode));
          }
        });
        setBarcodeSet(newBarcodeSet);
      }
    );
  }, []);

  useEffect(() => {
    if (checkboxClickCount >= 2) {
      window.location.reload();
    }
  }, [checkboxClickCount]);


















  useEffect(() => {
    const socket = io(`${INVENTORY_API_BASE_URL}`, {
      transports: ["websocket"],
      secure: true,
      rejectUnauthorized: false,
    });

    socket.on("connect", () => {
    });

    socket.on("barcode-scanned", (data) => {
      const barcodeValue = typeof data === "string" ? data : data.barcode;

      if (!barcodeValue) {
        console.warn("❗ Invalid barcode data received:", data);
        return;
      }

      if (!selectedShelfId) {
        alertify.alert("Please select a shelf before scanning a barcode.");
        return;
      }

      if (barcodeData.includes(barcodeValue)) {
        alertify.error(`Barcode "${barcodeValue}" is already scanned.`, 3);
        return;
      }

      AddBarcode(barcodeValue);
      setKeyForBarcode(barcodeValue);
      barcodeInputRef.current?.focus();
    });

    socket.on("disconnect", () => {
      console.warn("❌ WebSocket disconnected");
    });

    socket.on("connect_error", (err) => {
      console.error("⚠️ WebSocket Error:", err);
    });

    return () => {
      socket.disconnect();
    };
  }, [selectedShelfId, barcodeData]);

  const handleCheckboxChange = async (row) => {
    setShelfPage(1);
    setSelectedRow(row);
    setCheckboxClickCount(checkboxClickCount + 1);

    try {
      const response = await Axios.get(`${baseUrl}/getManageshelf`);

      setSelectedRowShelfData(response.data);
    } catch (error) {
      console.error("Error fetching shelf data:", error);
    }
  };

  const handleCheckboxChangeShelf = (shelfId) => {
    if (selectedShelfId === shelfId) {
      setSelectedShelfId(null);
    } else {
      setSelectedShelfId(shelfId);
    }
  };



  const AddBarcode = async (value) => {
    try {
      setKeyForBarcode("");

      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getKey/${value}`
      );
      const key = response.data.key;

      if (key) {
        const isBarcodeMatched = barcodeSet.has(key);

        if (selectedRow) {
          const Sku = selectedRow.sku;

          if (sameSkuCode(key, Sku)) {
            if (!isBarcodeMatched && !barcodeData.includes(key)) {
              setBarcodeData((prevData) => [...prevData, key]);

              setCount((prevCount) => prevCount + 1);

              if (
                selectedRowBarcodeData &&
                selectedRow.index in selectedRowBarcodeData
              ) {
                setSelectedRowBarcodeData((prevSelectedRowBarcodeData) => ({
                  ...prevSelectedRowBarcodeData,
                  [selectedRow.index]: {
                    barcode: key,
                    count: count,
                  },
                }));
              } else {
                setSelectedRowBarcodeData((prevSelectedRowBarcodeData) => ({
                  ...prevSelectedRowBarcodeData,
                  [selectedRow.index]: {
                    barcode: key,
                    count: 1,
                  },
                }));
              }

              alertify.success("Barcode scanned successfully", 3);

              return;
            } else {
              if (isBarcodeMatched) {
                alertify.error("Barcode Already Present in DB", 3);
              } else {
                alertify.error("Barcode Already Scanned", 3);
              }
            }
          } else {
            alertify.error("Invalid Barcode", 3);
          }
        }
      } else {
        alertify.error("Key not found for the given value", 3);
      }
    } catch (error) {
      console.error("Error fetching key:", error);
    }
  };




  useEffect(() => {
    if (data1) {
      const normalizedSearchQuery = searchQuery.trim().toLowerCase();
      const filtered = data1.filter((row1) => {
        const orderNumber = String(row1.orderno || "").toLowerCase();
        const sku = String(row1.sku || "").toLowerCase();
        return Boolean(orderNumber || sku) &&
          (!normalizedSearchQuery ||
            orderNumber.includes(normalizedSearchQuery) ||
            sku.includes(normalizedSearchQuery));
      });
      setFilteredData(filtered);
    }
  }, [data1, searchQuery]);

  useEffect(() => {
    setBatchPage(1);
  }, [searchQuery]);

  useEffect(() => {
    setBarcodePage(
      Math.max(1, Math.ceil(barcodeData.length / SCAN_PAGE_SIZE))
    );
  }, [barcodeData.length]);

  useEffect(() => {


    const handleDocumentClick = (event) => {
      const clickedElement = event.target;
      if (
        barcodeInputRef.current &&
        clickedElement !== barcodeInputRef.current &&
        clickedElement.className !== "inboundsearch" &&
        !clickedElement.closest("button")
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [barcode, selectedShelfId]);

  function handleSubmit() {
    if (barcodeData.length === 0) {
      alertify.alert("No barcodes have been scanned");
      return;
    }

    const orderNumber = selectedRow.orderno;
    const BatcId = selectedRow.batchid;
    const selectedRowData = selectedRowBarcodeData[selectedRow.index];
    const Titl = selectedRow.title;

    if (!selectedRowData) {
      alertify.alert("No barcode scanned for the selected row");
      return;
    }

    const dataToSend = {
      orderno: orderNumber,
      barcodeData: barcodeData,
      count: count,
      BatchID: BatcId,
      Title: Titl,
    };

    swal({
      title: "Confirm Inbound",
      text: "Are you sure you want to submit the scanned data?",
      icon: "warning",
      buttons: ["Cancel", "OK"],
    }).then(async (confirmed) => {
      if (!confirmed) return;

      const selectedShelf = selectedRowShelfData.find(
        (shelf) => shelf._id === selectedShelfId
      );

      if (!selectedShelf) return;

      const { presentquantity, emptyspace, _id } = selectedShelf;
      const updatedBooksAvailable = presentquantity + count;
      const updatedEmptySpace = emptyspace - count;

      setLoading(true);
      try {
        await Axios.put(`${INVENTORY_API_BASE_URL}/putaway`, {
          id: _id,
          presentquantity: updatedBooksAvailable,
          emptyspace: updatedEmptySpace,
          barcodeData: barcodeData,
        });

        await Axios.post(
          `${INVENTORY_API_BASE_URL}/scanInbound`,
          dataToSend
        );
        swal({
          title: "Putaway Created",
          text: "",
          icon: "success",
        });

        window.location.reload();
      } catch (error) {
        alertify("Service error");
        console.error(error);
      } finally {
        setLoading(false);
      }
    });
  }

  return (
    <main className="scanhashing-container scan-inbound-page">
      <div className="scan-inbound-workspace">
        <header className="scan-inbound-header">
          <div className="scan-inbound-heading">
            <span className="scan-inbound-eyebrow">INVENTORY / RECEIVING</span>
            <h1>Scan Inbound</h1>
            <p>Select a received batch and destination shelf, then scan each barcode.</p>
          </div>
          <div className="scan-inbound-overview" aria-label="Inbound scan summary">
            <div className="scan-overview-item">
              <span>Matching batches</span>
              <strong>{filteredData.length.toLocaleString()}</strong>
            </div>
            <div className="scan-overview-item scan-overview-item--accent">
              <span>Scanned this session</span>
              <strong>{count.toLocaleString()}</strong>
            </div>
          </div>
        </header>

        <section className="scan-panel" aria-labelledby="scan-batch-title">
          <div className="scan-panel-heading">
            <div>
              <span className="scan-section-kicker">STEP 1</span>
              <h2 id="scan-batch-title">Choose an inbound batch</h2>
              <p>Select the GRN that contains the items being received.</p>
            </div>
            <div className="scan-search">
              <label htmlFor="scan-order-search">Find an order or SKU</label>
              <input
                id="scan-order-search"
                className="inboundsearch"
                type="search"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder="Search order number or SKU"
                aria-label="Search inbound batches by order number or SKU"
              />
            </div>
          </div>

          <div className="scan-table-wrap">
            <Table className="scan-table scan-batch-table" aria-label="Inbound batches">
              <thead>
                <tr>
                  <th scope="col">Select</th>
                  <th scope="col">Order no.</th>
                  <th scope="col">Batch ID</th>
                  <th scope="col">Title</th>
                  <th scope="col">Medium</th>
                  <th scope="col">Received</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td className="scan-table-empty" colSpan={6}>
                      {searchQuery
                        ? "No batches match this order number or SKU."
                        : "No inbound batches are available."}
                    </td>
                  </tr>
                ) : (
                  visibleBatchRows.map((row2, index) => (
                    <tr
                      key={row2._id || index}
                      className={selectedRow === row2 ? "is-selected" : undefined}
                    >
                      <td data-label="Select" className="scan-checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selectedRow === row2}
                          aria-label={"Select order " + row2.orderno}
                          onChange={() => handleCheckboxChange(row2)}
                        />
                      </td>
                      <td data-label="Order number" title={row2.orderno}>
                        {row2.orderno}
                      </td>
                      <td data-label="Batch ID" title={row2.batchid}>
                        <span className="scan-value-chip">{row2.batchid}</span>
                      </td>
                      <td
                        data-label="Title"
                        className="scan-title-cell"
                        title={row2.title}
                      >
                        {row2.title}
                      </td>
                      <td data-label="Medium">{row2.Medium}</td>
                      <td data-label="Received">
                        <span className="scan-quantity-chip">
                          {row2.challanquantity}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
          {renderPagination(
            "Inbound batches",
            batchPage,
            filteredData.length,
            setBatchPage
          )}
        </section>

        {selectedRow && (
          <section className="scan-panel" aria-labelledby="scan-shelf-title">
            <div className="scan-panel-heading scan-shelf-heading">
              <div>
                <span className="scan-section-kicker">STEP 2</span>
                <h2 id="scan-shelf-title">Choose a destination shelf</h2>
                <p>
                  Order {selectedRow.orderno} <span aria-hidden="true">·</span>{" "}
                  SKU {selectedRow.sku}
                </p>
              </div>
              <span
                className={
                  selectedShelfId
                    ? "scan-selection-status is-selected"
                    : "scan-selection-status"
                }
              >
                {selectedShelfId ? "Shelf selected" : "Select one shelf"}
              </span>
            </div>

            <div className="scan-table-wrap">
              <Table className="scan-table scan-shelf-table" aria-label="Available shelves">
                <thead>
                  <tr>
                    <th scope="col">Select</th>
                    <th scope="col">Rack</th>
                    <th scope="col">Shelf</th>
                    <th scope="col">Type</th>
                    <th scope="col">Capacity</th>
                    <th scope="col">Added</th>
                    <th scope="col">Empty</th>
                    <th scope="col">Current</th>
                    <th scope="col">After putaway</th>
                  </tr>
                </thead>
                <tbody>
                  {matchingShelfRows.length === 0 ? (
                    <tr>
                      <td className="scan-table-empty" colSpan={9}>
                        No shelf locations were found for this SKU.
                      </td>
                    </tr>
                  ) : (
                    visibleShelfRows.map((item) => {
                        const updatedBooksAvailable =
                          selectedShelfId === item._id
                            ? item.presentquantity + count
                            : item.presentquantity;
                        const updatedEmptySpace =
                          selectedShelfId === item._id
                            ? item.emptyspace - count
                            : item.emptyspace;
                        const selectedShelf = selectedRowShelfData.find(
                          (shelf) => shelf._id === selectedShelfId
                        );
                        const { presentquantity, emptyspace, _id } =
                          selectedShelf || {};

                        return (
                          <tr
                            key={item._id || item.id}
                            className={
                              selectedShelfId === item._id
                                ? "is-selected"
                                : undefined
                            }
                          >
                            <td data-label="Select" className="scan-checkbox-cell">
                              <input
                                type="checkbox"
                                checked={selectedShelfId === item._id}
                                aria-label={
                                  "Select rack " +
                                  item.rackno +
                                  ", shelf " +
                                  item.shelfno
                                }
                                onChange={() =>
                                  handleCheckboxChangeShelf(item._id)
                                }
                              />
                            </td>
                            <td data-label="Rack">{item.rackno}</td>
                            <td data-label="Shelf">{item.shelfno}</td>
                            <td data-label="Type">{item.type}</td>
                            <td data-label="Capacity">{item.capacity}</td>
                            <td data-label="Added quantity">
                              <span className="scan-quantity-chip">{count}</span>
                            </td>
                            <td data-label="Empty space">{updatedEmptySpace}</td>
                            <td data-label="Current quantity">
                              {item.presentquantity}
                            </td>
                            <td data-label="After putaway">
                              <strong className="scan-projected-quantity">
                                {updatedBooksAvailable}
                              </strong>
                            </td>
                          </tr>
                        );
                      })
                  )}
                </tbody>
              </Table>
            </div>
            {renderPagination(
              "Available shelves",
              shelfPage,
              matchingShelfRows.length,
              setShelfPage
            )}
          </section>
        )}

        <div className="scan-inbound-work-grid">
          <section className="scan-panel scan-capture-panel" aria-labelledby="scan-barcode-title">
            <div className="scan-panel-heading">
              <div>
                <span className="scan-section-kicker">STEP 3</span>
                <h2 id="scan-barcode-title">Scan inbound barcodes</h2>
                <p>
                  {selectedShelfId
                    ? "Scan or type a barcode and press Enter."
                    : "Select an inbound batch and shelf before scanning."}
                </p>
              </div>
              <span
                className={
                  selectedShelfId
                    ? "scan-ready-badge is-ready"
                    : "scan-ready-badge"
                }
              >
                <span aria-hidden="true" />
                {selectedShelfId ? "Ready to scan" : "Waiting for shelf"}
              </span>
            </div>

            <label className="scan-barcode-label" htmlFor="inbound-barcode-input">
              Barcode
            </label>
            <div className="scan-barcode-wrap">
              <span className="scan-barcode-icon" aria-hidden="true">
                #
              </span>
              <input
                id="inbound-barcode-input"
                className="scan-barcode-input"
                type="text"
                ref={barcodeInputRef}
                value={keyForBarcode}
                onChange={(event) => setKeyForBarcode(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    if (!selectedShelfId) {
                      swal({
                        title: "Shelf Not Selected",
                        text: "Please select a shelf before scanning a barcode.",
                        icon: "warning",
                        button: "OK",
                      });

                      setKeyForBarcode("");
                      barcodeInputRef.current.focus();
                      return;
                    }
                    AddBarcode(keyForBarcode);
                    setKeyForBarcode("");
                  }
                }}
                placeholder="Scan or enter barcode"
                autoComplete="off"
              />
            </div>
            <p className="scan-barcode-hint">
              The scan field stays focused while you work through a batch.
            </p>
            {loading && (
              <div className="scan-processing" role="status">
                <span className="scan-spinner" aria-hidden="true" />
                Saving inbound scan…
              </div>
            )}
          </section>

          <aside className="scan-session-panel" aria-label="Scanned barcode session">
            <div className="scan-session-heading">
              <div>
                <span className="scan-section-kicker">CURRENT BATCH</span>
                <h2>Scanned barcodes</h2>
              </div>
              <span className="scan-session-count">{count.toLocaleString()}</span>
            </div>

            {barcodeData.length > 0 ? (
              <ul className="scan-barcode-list">
                {visibleBarcodes.map((barcode, index) => (
                  <li key={index} title={barcode}>
                    <span className="scan-barcode-code">{barcode}</span>
                    <span className="scan-scan-state">Scanned</span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="scan-empty-state">
                <span aria-hidden="true">—</span>
                <p>Scanned barcode values will appear here.</p>
              </div>
            )}

            {renderPagination(
              "Scanned barcodes",
              barcodePage,
              barcodeData.length,
              setBarcodePage
            )}

            <button
              className="scan-save-button"
              type="button"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving…" : "Save scanned ID"}
            </button>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default Scanhashing;
